import { Box } from '@mui/material';
import React, { useState, useEffect } from 'react';

const RADIUS = 7

const MultiColorProgressBar = ({ element_list, param, is_summary }) => {
    const [item_list, setItemList] = useState([])

    useEffect(() => {
        let _item_list = []
        if (is_summary) {
            const l = element_list.count_total
            const true_length = element_list.count_present
            const false_length = element_list.count_not_present
            const undefined_length = l-element_list.count_not_present-element_list.count_present
            if (true_length>0){
                _item_list.push({ value: 100 * true_length / l, color: 'green' })
            }
            if (false_length>0){
                _item_list.push({ value: 100 * false_length / l, color: 'red' })
            }
            if (undefined_length>0){
                _item_list.push({ value: 100 * undefined_length / l, color: 'lightgrey' })
            }
        } else {
            const l = element_list.length
            const true_length = element_list.filter(c => c[param] === true).length
            const false_length = element_list.filter(c => c[param] === false).length
            const undefined_length = element_list.filter(c => c[param] === undefined).length
            if (true_length>0){
                _item_list.push({ value: 100 * true_length / l, color: 'green' })
            }
            if (false_length>0){
                _item_list.push({ value: 100 * false_length / l, color: 'red' })
            }
            if (undefined_length>0){
                _item_list.push({ value: 100 * undefined_length / l, color: 'lightgrey' })
            }
        }
        if (_item_list.length>0 && isNaN(_item_list[0].value)){
            setItemList([])
        }else{
            setItemList(_item_list)
        }
    }, [element_list])




    return (

        <Box sx={{ display: 'flex', width: '100%', border: '1px solid white', borderRadius: 2 }}>
            {item_list.map((item, k) => (
                <span key={k} style={{ height: '100%', 'backgroundColor': item.color, 'width': item.value + '%', display: 'inline-block', ...getBorderRadius(k, item_list.length)  }} >
                    &nbsp;
                </span>
            ))}
        </Box>
    );
}

const rad = 5

const getBorderRadius = (index, item_length) => {
    let d = {}
    if (index === 0){
        d.borderBottomLeftRadius = rad
        d.borderTopLeftRadius = rad
    }
    if (index=== (item_length-1)){
        d.borderBottomRightRadius = rad
        d.borderTopRightRadius = rad
    }
    return d
}

export default MultiColorProgressBar;